/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListPersonalCharacteristicsPersonalCharacteristicDtoFromJSON, ListPersonalCharacteristicsPersonalCharacteristicDtoToJSON, } from './ListPersonalCharacteristicsPersonalCharacteristicDto.js';
/**
 * Check if a given object implements the ListPersonalCharacteristicsResult interface.
 */
export function instanceOfListPersonalCharacteristicsResult(value) {
    if (!('personalCharacteristics' in value) || value['personalCharacteristics'] === undefined)
        return false;
    return true;
}
export function ListPersonalCharacteristicsResultFromJSON(json) {
    return ListPersonalCharacteristicsResultFromJSONTyped(json, false);
}
export function ListPersonalCharacteristicsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'personalCharacteristics': (json['personalCharacteristics'].map(ListPersonalCharacteristicsPersonalCharacteristicDtoFromJSON)),
    };
}
export function ListPersonalCharacteristicsResultToJSON(json) {
    return ListPersonalCharacteristicsResultToJSONTyped(json, false);
}
export function ListPersonalCharacteristicsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'personalCharacteristics': (value['personalCharacteristics'].map(ListPersonalCharacteristicsPersonalCharacteristicDtoToJSON)),
    };
}
